// /**
//  * Online-Kredit Landing Page - Main App Component
//  * 
//  * A professional German credit card landing page built with React.
//  * Features 3D card animations, modal form, and EmailJS integration.
//  */

// import { useState, useCallback } from 'react'
// import Header from './components/Header'
// import Hero from './components/Hero'
// import CardSection from './components/CardSection'
// import Features from './components/Features'
// import Footer from './components/Footer'
// import Modal from './components/Modal'
// import { ModalProvider } from './context/ModalContext'
// import LegalPage from './components/legalpage'

// function App() {
//   return (
//     <ModalProvider>
//       <div className="app">
//         <Header />
//         <Hero />
//         <CardSection />
//         <Features />
//         <Footer />
//         <Modal />
//       </div>
//     </ModalProvider>
//   )
// }

// export default App


/**
 * Online-Kredit Landing Page - Main App Component
 * 
 * A professional German credit card landing page built with React.
 * Features 3D card animations, modal form, EmailJS integration, and legal pages.
 */
/**
 * Online-Kredit Landing Page - Main App Component
 * 
 * A professional German credit card landing page built with React.
 * Features 3D card animations, modal form, EmailJS integration, and legal pages.
 */

import { BrowserRouter  as Router, Routes, Route, useLocation } from 'react-router-dom'
import Header from './components/Header'
import Hero from './components/Hero'
import CardSection from './components/CardSection'
import Features from './components/Features'
import Footer from './components/Footer'
import Modal from './components/Modal'
import LegalPage from './components/legalpage'
import { ModalProvider } from './context/ModalContext'

// Main landing page component
function LandingPage() {
  return (
    <>
      <Header />
      <Hero />
      <CardSection />
      <Features />
    </>
  )
}

function AppContent() {
  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/legal" element={<LegalPage />} />
      </Routes>
      <Footer />
      <Modal />
    </div>
  )
}

function App() {
  return (
    <ModalProvider>
      <Router>
        <AppContent />
      </Router>
    </ModalProvider>
  )
}

export default App